<template>
  <div v-if="record.length>=2">
    <div>
      <div class="flex-container">
        <span class="name-right">{{ hashTime(data.name,record[0]) + (unit?('('+record[0][unit] +')'):'') }}:</span>
        <span v-if="record[0][data.value]" class="time-left">{{record[0][data.value]}}
          <el-tooltip content="折叠更多" v-if="showToolTip[index]">
            <i class="el-icon-caret-top iconMore" @click="openMore(index)"></i>
          </el-tooltip>
          <el-tooltip content="展开更多" v-if="!showToolTip[index]">
            <i class="el-icon-caret-bottom iconMore" @click="openMore(index)"></i>
          </el-tooltip>
        </span>
      </div>
      <div v-for="(con,index1) in record" :key="index1" v-if="showToolTip[index]">
        <br v-if="index1 !== 0">
        <div v-if="index1 !== 0" class="flex-container">
          <span class="name-right">{{ hashTime(data.name,con) + (unit?('('+con[unit] +')'):'') }} : </span>
          <span v-if="con[data.value]" class="time-left">{{ con[data.value] }}</span>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    {{hashTime(data.name,record[0]) + (unit?('('+record[0][unit] +')'):'')}} : {{record[0][data.value] + (unit?'(支)':'') }}
  </div>
</template>

<script>
export default {
  name: "ExFoldCellToo",
  props: ['data','record','index','unit'],
  data() {
    return {
      showToolTip: [],
    }
  },
  methods: {
    hashTime(data,record){
      if (data.includes('.')) {
        const keys = data.split('.');
        return keys.reduce((obj, key) => obj && obj[key], record);
      }
      return record[data]
    },
    openMore(index) {
      this.$set(this.showToolTip, index, !this.showToolTip[index]);
    }
  }
}
</script>

<style scoped>
.iconMore {
  color: #4eaad4;
  cursor: pointer;
}

</style>
